import {Component, Input, OnInit} from '@angular/core';
import {ModalController, NavController} from '@ionic/angular';
import {APIService} from 'src/app/API.service';
import {Router} from '@angular/router';
import {EditUserPage} from '../edit-user/edit-user.page';
import {SessionService} from '../services/session.service';
import {DataStore} from '@aws-amplify/datastore';
import {Contract, PermissionType, User} from '../../models';

@Component({
  selector: 'app-trc20',
  templateUrl: './trc20.page.html',
  styleUrls: ['./trc20.page.scss'],
})
export class Trc20Page implements OnInit {

  userList = [];
  filteredUserList: any;
  cssClass: string;
  filters = {
    name : ''
  }

  constructor(
    public navController: NavController,
    public apiService: APIService,
    public sessionService: SessionService,
    public router: Router,
    public modalController: ModalController,
    ) {
    }

    async ngOnInit() {
      this.refreshUserList();
  }

  private async refreshUserList(filters = undefined) {
      let filteredUsers = this.userList = [];

      filteredUsers = (await (await DataStore.query(User)).filter(u => {
        return u.TRC20Active == true;
      }));

      if(filters != undefined) {
        filteredUsers = filteredUsers.filter(u => {
          let matcheNames = '.+';

          if (filters['name'].trim().length != 0) matcheNames = filters['name'];
          const reName = new RegExp(matcheNames, 'gi');

          return `${u.name} ${u.lastname}`.match(reName);
        });
      }

      this.userList = filteredUsers;
  }

  filterUsers() {
    this.refreshUserList(this.filters);
  }

  back() {
    this.navController.back();
  }

  async copy(string) {
    
    let aux = document.createElement('input');
    aux.setAttribute('value', string);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand('copy');
    
    document.body.removeChild(aux);
  }

}
